import styled, { css } from 'styled-components';
import { HStack } from '@montel/montelpro-shared-components-v2';

export const StyledHeaderBar = styled.div<{ $breakpoint?: string }>`
	position: fixed;
	top: 0;
	width: 100%;

	a {
		text-decoration: none;
	}

	${({ theme }) => {
		const { colors, zIndices } = theme;
		return css`
			height: 5rem;
			z-index: ${zIndices.docked};
			background-color: ${colors.bgMainContainer};
		`;
	}}
`;

export const StyledHeaderBarContent = styled.div<{ $breakpoint?: string }>`
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-direction: row;
	height: 100%;
	margin: ${({ theme }) => `0 ${theme.spacing.md}`};
`;

export const SecondaryHeaderContainer = styled(HStack).attrs({
	fullWidth: true,
	wrap: 'nowrap',
	align: 'center',
	gap: '1.5rem',
})`
	${({ theme }) => css`
		margin: ${theme.spacing.md} 0;

		> h1 {
			white-space: nowrap;
		}
	`}
`;
